<template>
  <div>

    <nav class="navbar customNavbar" >
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-two-thirds">
          <h2 class="title is-2">Resultados de búsqueda</h2>
          <br/>
          <div class="columns">
            <div class="column"></div>
            <div class="column is-6">
              <div class="field has-addons">
                <p class="control is-expanded">
                    <input v-model="searchText" :class="{'input': true, 'is-danger': errors.has('searchText') }" type="text" name="searchText" />
                    <span v-show="errors.has('searchText')" class="help is-danger">{{ errors.first('searchText') }}</span>
                </p>
                <div class="control">
                    <button class="button customButton" v-on:click="searchAgain">Buscar</button>
                </div>
              </div>
            </div>
            <div class="column"></div>
          </div>
          <article class="message is-info" v-for="searchItem of searchList" >
            <div class="message-body">
              <div class="searchContent" style="height: 70px">
                <h2 class="searchTitle"><i><b>{{searchItem.description}}</b></i></h2>
                <a class="newsLink" style="margin-top: 30px;" v-on:click="searchDetail(searchItem.link)">Ver más</a>
              </div>
            </div>
          </article>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
import FooterComponent from './FooterComponent'

export default {
  name: 'landing',
  components: {
    FooterComponent
  },
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      searchList: [],
      searchText: ''
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    searchDetail: function (searchId) {
      this.$router.push(searchId)
    },
    searchAgain () {
      console.log(this.searchText)
      ApiClient.search(this.searchText).then(response => {
        if (response.data.success) {
          this.searchList = response.data.results
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    }
  },
  created () {
    this.searchText = this.$route.params.search
    this.searchAgain()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 80px;
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .newsTitle {
      font-size: medium;
      text-align: left;
  }
  .newsInfo {
    font-size: smaller;
    text-align: left;
  }
  .newsLink {
    font-size: smaller;
    float: right;
  }
  .newsImage {
    margin-right: 50px;
  }
  .newsContent {
    margin-bottom: 20px;
  }
  .footerInfo {
    margin-left: 100px;
    margin-right:100px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:100px;
    margin-top: 60px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// SearchComponent.vue?69e74511